import { filterUndefined, keysToSnakeCaseDeep } from '@frontend/utils';

import type { HasQuery } from '../types';

export const composeQuery = (
  query: HasQuery['query'],
  shouldConvertKeysToSnakeCase = true,
): string => {
  let _query: string = query ? '?' : '';

  if (query && typeof query === 'object') {
    _query += new URLSearchParams(
      shouldConvertKeysToSnakeCase
        ? (keysToSnakeCaseDeep(filterUndefined(query)) as Record<
            string,
            string
          >)
        : filterUndefined(query),
    ).toString();
  } else if (query) {
    _query += new URLSearchParams(query).toString();
  }

  return _query;
};
